<div class="dash-home">

  <!-- Stat cards -->
  <div class="stat-row">
    <a class="stat-card" *ngFor="let s of stats" [ngClass]="s.tone" [routerLink]="s.route">
      <div class="stat-text">
        <span class="stat-label">{{ s.label }}</span>
        <span class="stat-value" *ngIf="!loading">{{ s.value }}</span>
        <span class="stat-skeleton" *ngIf="loading"></span>
      </div>
      <span class="stat-ico"><i [class]="s.icon"></i></span>
    </a>
  </div>

  <!-- Panels -->
  <div class="panel-row">

    <!-- Recent orders -->
    <section class="panel">
      <header class="panel-head">
        <div class="panel-title">
          <span class="panel-ico violet"><i class="fa-solid fa-box-open"></i></span>
          <div>
            <h3>Recent Orders</h3>
            <p>Your latest service orders</p>
          </div>
        </div>
        <a routerLink="/customer-product-order-history" class="panel-link">View all <i class="fa-solid fa-arrow-right"></i></a>
      </header>

      <div class="panel-body">
        <div class="skeleton-list" *ngIf="loading">
          <div class="skeleton-row" *ngFor="let i of [1,2,3,4]"></div>
        </div>

        <ng-container *ngIf="!loading">
          <div class="list-item" *ngFor="let o of orders">
            <span class="li-ico violet"><i class="fa-solid fa-box-open"></i></span>
            <div class="li-text">
              <span class="li-title">{{ o?.productName || o?.serviceName || 'Order' }}</span>
              <span class="li-sub">{{ (o?.createdAt || o?.orderDate) | date:'dd MMM yyyy' }}</span>
            </div>
            <div class="li-end">
              <span class="li-amount">{{ gS.currencySign }} {{ o?.orderAmount || o?.amount || 0 }}</span>
              <span class="li-badge" [ngClass]="(o?.orderStatus || o?.status || '') | lowercase">{{ o?.orderStatus || o?.status || '—' }}</span>
            </div>
          </div>

          <div class="empty" *ngIf="!orders.length">
            <i class="fa-solid fa-box-open"></i>
            <p>No orders yet</p>
          </div>
        </ng-container>
      </div>
    </section>

    <!-- Recent transactions -->
    <section class="panel">
      <header class="panel-head">
        <div class="panel-title">
          <span class="panel-ico green"><i class="fa-solid fa-clock-rotate-left"></i></span>
          <div>
            <h3>Recent Transactions</h3>
            <p>Your latest wallet activity</p>
          </div>
        </div>
        <a routerLink="/customer-transactions-history" class="panel-link">View all <i class="fa-solid fa-arrow-right"></i></a>
      </header>

      <div class="panel-body">
        <div class="skeleton-list" *ngIf="loading">
          <div class="skeleton-row" *ngFor="let i of [1,2,3,4]"></div>
        </div>

        <ng-container *ngIf="!loading">
          <div class="list-item" *ngFor="let t of transactions">
            <span class="li-ico" [ngClass]="isCredit(t) ? 'green' : 'red'">
              <i class="fa-solid" [ngClass]="isCredit(t) ? 'fa-arrow-down' : 'fa-arrow-up'"></i>
            </span>
            <div class="li-text">
              <span class="li-title">{{ t?.description || t?.expenseType || 'Transaction' }}</span>
              <span class="li-sub">{{ t?.transactionDate | date:'dd MMM yyyy' }}</span>
            </div>
            <div class="li-end">
              <span class="li-amount" [ngClass]="isCredit(t) ? 'pos' : 'neg'">
                {{ isCredit(t) ? '+' : '-' }} {{ gS.currencySign }} {{ t?.transactionAmount || t?.amount || 0 }}
              </span>
            </div>
          </div>

          <div class="empty" *ngIf="!transactions.length">
            <i class="fa-solid fa-clock-rotate-left"></i>
            <p>No transactions yet</p>
          </div>
        </ng-container>
      </div>
    </section>
  </div>

  <!-- Quick actions -->
  <section class="quick">
    <h3 class="quick-title">Quick Actions</h3>
    <div class="quick-grid">
      <a routerLink="/recharge-wallet" class="quick-card"><span class="qc-ico teal"><i class="fa-solid fa-wallet"></i></span> Recharge Wallet</a>
      <a routerLink="/userdetailPage" class="quick-card"><span class="qc-ico violet"><i class="fa-regular fa-user"></i></span> Edit Profile</a>
      <a routerLink="/customer-product-order-history" class="quick-card"><span class="qc-ico green"><i class="fa-solid fa-box-open"></i></span> My Orders</a>
      <a routerLink="/support-chat" class="quick-card"><span class="qc-ico amber"><i class="fa-regular fa-life-ring"></i></span> Get Support</a>
    </div>
  </section>

</div>
